import { createContext, use } from 'react';
import type { ReactNode } from 'react';

import type { ModalAction } from './schemas/modal.schema';

type ModalContextValue = {
  headingId?: string;
  title?: ReactNode;
  onClose?: () => void;
  actions?: ModalAction[];
};

export const ModalContext = createContext<ModalContextValue | undefined>(undefined);

export const useModalContext = (): ModalContextValue => use(ModalContext) ?? {};
